import * as angular from "angular";

export class UserService {
    private apiRoot: string;
    private v2Root: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/campaign/user";
        this.v2Root = "/v2/user";
    }

    all(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/alldash", data);
    }

    allFromCampaignExtra(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/all/campaign_extra", data);
    }

    onlineNow(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/online_now", { params: data });
    }

    profileImage(uid: string | number): Promise<object> {
        return this.$http.get(this.apiRoot + "/profile_image/" + uid);
    }

    usersCount(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/userscount", data);
    }

    headlineStats(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/headline_stats", data);
    }

    seats(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/seats", data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/" + data.uid, data);
    }

    locationdays(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/locationdays", data);
    }

    remove(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/remove/" + data.id, data);
    }

    bulkDelete(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/bulk_remove", data);
    }

    bulkActivate(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/activate", data);
    }

    bulkDeactivate(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/deactivate", data);
    }

    grant(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/grant", data);
    }

    revoke(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/revoke", data);
    }

    extend_trial(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/extend_trial", data);
    }

    add(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/add", data);
    }

    allCampaign(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/all/" + data.id, data);
    }

    self_remove(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/self_remove", data);
    }

    bulk_self_remove(ids: number[]): Promise<object> {
        return this.$http.post(this.apiRoot + "/bulk_self_remove", {
            ids: ids,
        });
    }

    reset2fa(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/reset2fa/" + data.id, data);
    }

    requestDiagnostics(data: any): Promise<object> {
        return this.$http.post("/v2/diagnostics/request/" + data.id, data);
    }
}

angular.module("vcServices").service("UserService", UserService);
